import { render, staticRenderFns } from "./Reallocation.vue?vue&type=template&id=29dd6600"
import script from "./Reallocation.vue?vue&type=script&lang=js"
export * from "./Reallocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports